<style scoped lang="scss">
    @import "../../styles/var";

    .textarea {
        display: inline-block;
        width: 100%;
        border-radius: 4px;
        border: 1px solid #dcdfe6;

        &.focus {
            border: 1px solid $mainColor;
        }
    }

    textarea {
        color: #606266;
        outline: none;
        resize: none;
        width: 100%;
        border: 0px none;

        &::-webkit-input-placeholder {
            color: #c0c4cc;
        }
    }

    p {
        justify-content: flex-end;
        line-height: 20px;
    }
</style>
<template>
    <div class="textarea pl10 pr10 pt5" :class="{focus:isFocus}">
        <textarea v-model="text" :readonly="readonly" :maxlength="maxlength" :placeholder="placeholder" @focus="focus"
                  @blur="blur" @input="input"></textarea>
        <p class="fs12 color_999 flex">{{text.length}}/{{maxlength}}</p>
    </div>
</template>

<script>
  export default {
    name: "v-textarea",
    props: {
      value: [String, Number],
      placeholder: {
        type: String,
        default: ''
      },
      maxlength: {
        type: Number,
        default: 150
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isFocus: false,
        text: ''
      }
    },
    watch: {
      value(newV) {
        this.text = newV || '';
      }
    },
    methods: {
      focus() {
        this.isFocus = true;
      },
      blur() {
        this.isFocus = false;
      },
      input(e) {
        this.$emit('input', e.target.value);
      }
    },
  }
</script>

